(function($)
{
    $.extend(true, orion, {
        api: {
            notifications: {}
        }
    });

    var
        api = orion.api.notifications,
        uri = '/api-notifications',
        localeCode = $('meta[name="localeCode"]').attr('content'),
        languageCode = localeCode.substring(0, 2);

    function read()
    {
        var
            promise = $.ajax(uri + '-' + languageCode, {
                cache: false,
                headers: {
                    'Accept': 'application/json',
                },
                method: 'GET'
            });

        return promise;
    }

    function markAsRead(notificationId)
    {
        var
            promise = $.ajax(uri + '-' + languageCode, {
                cache: false,
                headers: {
                    'Accept': 'application/json',
                },
                dataType: 'json',
                contentType: 'application/json',
                data: JSON.stringify({ notificationId: notificationId }),
                method: 'PUT'
            });

        return promise;
    }

    function markAllUnimportantAsRead()
    {
        var
            promise = $.ajax(uri + '-' + languageCode, {
                cache: false,
                headers: {
                    'Accept': 'application/json',
                },
                dataType: 'json',
                contentType: 'application/json',
                data: JSON.stringify({ markAll: true }),
                method: 'PUT'
            });

        return promise;
    }

    api.read = read;
    api.markAsRead = markAsRead;
    api.markAllUnimportantAsRead = markAllUnimportantAsRead;
})(jQuery);
